import React from 'react';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';
import { useLanguage } from '../../../i18n/LanguageContext';

const EmptyState = ({ searchQuery, onClearSearch }) => {
  const { t } = useLanguage();

  return (
    <div className="empty-state flex flex-col items-center justify-center py-12 md:py-16 lg:py-20 px-4">
      <div className="empty-state-icon bg-muted/50 rounded-full p-6 md:p-8 mb-4 md:mb-6">
        <Icon name="Search" size={48} color="var(--color-muted-foreground)" />
      </div>
      
      <h3 className="text-xl md:text-2xl font-heading font-semibold text-foreground mb-2 text-center">
        {t('emptyStateTitle')}
      </h3>
      
      <p className="text-sm md:text-base text-muted-foreground text-center mb-6 max-w-md">
        {searchQuery 
          ? t('emptyStateSearchMsg', { query: searchQuery })
          : t('emptyStateCategoryMsg')}
      </p>

      {searchQuery && (
        <Button
          variant="outline"
          onClick={onClearSearch}
          iconName="X"
          iconPosition="left"
          iconSize={16}
          className="touch-target transition-smooth active:scale-96"
        >
          {t('clearSearch')}
        </Button>
      )}
    </div>
  );
};

export default EmptyState;